// Mock data for Eventime landing page

export const mockData = {
  company: {
    name: "Eventime",
    tagline: "Panggung Komunitas, Waktu untuk Bersinar!",
    description: "Kami adalah platform yang berdedikasi untuk menyelenggarakan dan mempromosikan acara komunitas di bidang olahraga dan esports. Kami percaya bahwa setiap komunitas layak mendapatkan pengalaman acara yang luar biasa.",
    closingStatement: "Di Eventime, setiap acara adalah festival, dan setiap partisipan adalah bintang."
  },
  
  services: [
    {
      id: 1,
      title: "Community Event Sport",
      description: "Menyelenggarakan event olahraga komunitas yang energik untuk membangun komunitas yang sehat dan aktif.",
      icon: "Trophy",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHp6dW1iYXxlbnwwfHx8fDE2ODk1MDEwMDB8MA&ixlib=rb-4.0.3&q=80&w=1080",
      detailedDescription: "Wujudkan turnamen olahraga yang berkesan dengan layanan manajemen acara end-to-end. Kami mengurus semua aspek dari perencanaan hingga eksekusi, termasuk koordinasi venue, sistem registrasi peserta, dan penjurian profesional.",
      features: [
        "Manajemen venue dan peralatan olahraga lengkap",
        "Sistem registrasi online yang mudah digunakan",
        "Tim wasit dan juri berpengalaman",
        "Live scoring dan dokumentasi acara",
        "Sertifikat dan trophy untuk pemenang",
        "Media coverage dan dokumentasi foto/video",
        "Koordinasi dengan sponsor dan mitra",
        "Support medis dan keamanan acara"
      ],
      pastEvents: [
        "Jakarta Basketball League 2024 - 150 peserta",
        "Turnamen Futsal Komunitas Jakarta - 32 tim",
        "Marathon Jakarta Community - 500+ pelari",
        "Badminton Championship Series - 200 peserta"
      ],
      packages: [
        {
          name: "Paket Starter",
          description: "Up to 100 participants"
        },
        {
          name: "Paket Professional",
          description: "Up to 300 participants"
        },
        {
          name: "Paket Premium",
          description: "Up to 500+ participants"
        }
      ]
    },
    {
      id: 2,
      title: "Lifestyle Segment",
      description: "Ciptakan Event Lifestyle yang Tak Terlupakan. Membantu Anda menciptakan ekosistem lifestyle dengan mengkombinasikan industri terkait untuk pengalaman yang autentik.",
      icon: "Sparkles",
      image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsaWZlc3R5bGUlMjBldmVudHxlbnwwfHx8fDE2ODk1MDQwMDB8MA&ixlib=rb-4.0.3&q=80&w=1080",
      detailedDescription: "Ciptakan ekosistem lifestyle yang autentik dengan menggabungkan berbagai industri dalam satu event yang berkesan. Dari fashion, kuliner, hingga wellness, kami membantu Anda membangun pengalaman lifestyle yang holistik.",
      features: [
        "Kurasi brand dan komunitas lifestyle",
        "Integrasi multi-industri (fashion, food, wellness)",
        "Zona experiential marketing interaktif",
        "Kolaborasi dengan influencer dan creator",
        "Pop-up store dan booth showcase",
        "Workshop dan talkshow tematik",
        "Instagram-worthy photo spots",
        "Networking session eksklusif"
      ],
      pastEvents: [
        "Jakarta Lifestyle Festival 2024 - 80+ brand",
        "Urban Living Expo - 60 exhibitor",
        "Fashion & Food Fest - 100+ komunitas",
        "Wellness Weekend Market - 50+ vendor"
      ],
      packages: [
        {
          name: "Paket Lifestyle Basic",
          description: "Up to 50 brand partners"
        },
        {
          name: "Paket Lifestyle Pro",
          description: "Up to 100 brand partners"
        },
        {
          name: "Paket Lifestyle Premium",
          description: "Up to 150+ brand partners"
        }
      ]
    },
    {
      id: 3,
      title: "Virtual E-Sport & Sport Mix",
      description: "Kombinasi turnamen esports virtual dan aktivitas olahraga fisik dalam satu event untuk pengalaman hybrid yang komprehensif.",
      icon: "Monitor",
      image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxlc3BvcnRzJTIwc3BvcnRzfGVufDB8fHx8MTY4OTUwMjAwMHww&ixlib=rb-4.0.3&q=80&w=1080",
      detailedDescription: "Hadirkan pengalaman esports yang tak terlupakan dengan teknologi gaming terdepan dan produksi broadcast profesional. Dari Mobile Legends hingga PUBG Mobile, kami menciptakan turnamen yang memukau audiens dan peserta.",
      features: [
        "Setup gaming station dengan hardware premium",
        "Platform tournament bracket online",
        "Live streaming dengan kualitas HD",
        "Shoutcaster dan host profesional",
        "LED display dan lighting system",
        "Prize pool management",
        "Social media campaign",
        "Anti-cheat system dan monitoring"
      ],
      pastEvents: [
        "Mobile Legends Championship Jakarta - 64 tim",
        "PUBG Mobile Community Cup - 100 squad",
        "Free Fire Tournament Series - 128 peserta",
        "Valorant Community League - 32 tim"
      ],
      packages: [
        {
          name: "Paket Gaming Basic",
          description: "Up to 64 teams"
        },
        {
          name: "Paket Esports Pro",
          description: "Up to 128 teams"
        },
        {
          name: "Paket Championship",
          description: "Up to 200+ teams"
        }
      ]
    },
    {
      id: 4,
      title: "Eventime Expo",
      description: "Platform showcase besar untuk komunitas dan brand dengan berbagai booth, workshop, dan kompetisi menarik.",
      icon: "Trophy",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxleHBvJTIwZXZlbnR8ZW58MHx8fHwxNjg5NTAzMDAwfDA&ixlib=rb-4.0.3&q=80&w=1080",
      detailedDescription: "Wujudkan expo yang berkesan dengan platform showcase yang mempertemukan komunitas, brand, dan pengunjung dalam satu tempat. Kami mengatur semua aspek dari booth setup hingga aktivitas interaktif.",
      features: [
        "Booth setup dan desain profesional",
        "Sistem registrasi exhibitor dan visitor",
        "Workshop dan seminar area",
        "Kompetisi dan doorprize management",
        "Networking session terstruktur",
        "Digital catalog dan mobile app",
        "Live streaming acara utama",
        "Marketing support untuk exhibitor"
      ],
      pastEvents: [
        "Jakarta Gaming Expo 2024 - 100+ exhibitor",
        "Sports Community Fair - 80 booth",
        "Tech Innovation Showcase - 150 startup",
        "Community Festival Jakarta - 200+ komunitas"
      ],
      packages: [
        {
          name: "Paket Expo Basic",
          description: "Up to 50+ exhibitors"
        },
        {
          name: "Paket Expo Professional",
          description: "Up to 100+ exhibitors"
        },
        {
          name: "Paket Expo Premium",
          description: "Up to 200+ exhibitors"
        }
      ]
    }
  ],

  featuredEvents: [
    {
      id: 1,
      title: "Jakarta Gaming Championship 2025",
      date: "15 Februari 2025",
      location: "Jakarta Convention Center",
      description: "Turnamen esports terbesar di Jakarta dengan hadiah total 500 juta rupiah. Kompetisi Mobile Legends, PUBG Mobile, dan Free Fire.",
      type: "Esports",
      status: "Pendaftaran Dibuka"
    },
    {
      id: 2,
      title: "Badminton Community Cup",
      date: "28 Februari 2025",
      location: "GOR Soemantri Brodjonegoro",
      description: "Turnamen bulutangkis untuk komunitas dengan kategori pemula hingga advanced. Terbuka untuk semua usia.",
      type: "Olahraga",
      status: "Segera Dibuka"
    },
    {
      id: 3,
      title: "Virtual Racing League",
      date: "10 Maret 2025",
      location: "Online Event",
      description: "Kompetisi balap virtual menggunakan simulator terdepan. Berpartisipasi dari rumah dengan hadiah menarik.",
      type: "Virtual",
      status: "Coming Soon"
    }
  ],

  navigation: [
    { name: "Beranda", href: "#hero" },
    { name: "Tentang", href: "#about" },
    { name: "Layanan", href: "#services" },
    { name: "Acara", href: "#featured-events" },
    { name: "Kontak", href: "#contact" }
  ],

  images: {
    hero: "https://images.unsplash.com/photo-1700914297011-60e0e8d12c0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxzcG9ydHMlMjBjb21tdW5pdHklMjBldmVudHN8ZW58MHx8fHwxNzU4NTEyMjkxfDA&ixlib=rb-4.1.0&q=85"
  },

  contact: {
    formFields: [
      { name: "name", label: "Nama", type: "text", placeholder: "Masukkan nama Anda" },
      { name: "email", label: "Email", type: "email", placeholder: "nama@email.com" },
      { name: "message", label: "Pesan", type: "textarea", placeholder: "Ceritakan tentang acara yang Anda inginkan..." }
    ]
  }
};

// Mock form submission handler
export const handleContactSubmission = (formData) => {
  console.log("Mock form submission:", formData);
  
  // Simulate API call delay
  return new Promise((resolve) => {
    setTimeout(() => {
      // Store in localStorage for demo purposes
      const submissions = JSON.parse(localStorage.getItem('eventime_submissions') || '[]');
      submissions.push({
        ...formData,
        id: Date.now(),
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('eventime_submissions', JSON.stringify(submissions));
      
      resolve({ success: true, message: "Pesan Anda telah berhasil dikirim!" });
    }, 1000);
  });
};

// Service data in English
export const servicesEn = [
  {
    id: 1,
    title: "Community Event Sport",
    description: "Organizing energetic community sports events to build healthy and active communities.",
    icon: "Trophy",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHp6dW1iYXxlbnwwfHx8fDE2ODk1MDEwMDB8MA&ixlib=rb-4.0.3&q=80&w=1080",
    detailedDescription: "Create memorable sports tournaments with end-to-end event management services. We handle all aspects from planning to execution, including venue coordination, participant registration system, and professional judging.",
    features: [
      "Complete venue and sports equipment management",
      "Easy-to-use online registration system",
      "Experienced referee and judge team",
      "Live scoring and event documentation", 
      "Certificates and trophies for winners",
      "Media coverage and photo/video documentation",
      "Coordination with sponsors and partners",
      "Medical support and event security"
    ],
    pastEvents: [
      "Jakarta Basketball League 2024 - 150 participants",
      "Jakarta Community Futsal Tournament - 32 teams",
      "Jakarta Community Marathon - 500+ runners",
      "Badminton Championship Series - 200 participants"
    ],
    packages: [
      {
        name: "Starter Package",
        description: "Up to 100 participants"
      },
      {
        name: "Professional Package",
        description: "Up to 300 participants"
      },
      {
        name: "Premium Package",
        description: "Up to 500+ participants"
      }
    ]
  },
  {
    id: 2,
    title: "Virtual E-Sport & Sport Mix",
    description: "Comprehensive hybrid events combining virtual esports tournaments with physical sports activities for complete experience.",
    icon: "Gamepad2", 
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxlc3BvcnRzfGVufDB8fHx8MTY4OTUwMTAwMHww&ixlib=rb-4.0.3&q=80&w=1080",
    detailedDescription: "Experience the future of competitive events with our hybrid approach combining digital gaming excellence and traditional sports excitement. Perfect for modern communities seeking innovative tournament formats.",
    features: [
      "Professional gaming setup and equipment",
      "LED display and lighting system",
      "Prize pool management",
      "Live streaming and broadcast production",
      "Physical sports integration",
      "Professional esports tournament software",
      "Social media content creation",
      "Comprehensive event documentation"
    ],
    pastEvents: [
      "Jakarta Esports Festival 2024 - 200 teams",
      "Mobile Legends Community Championship - 150 teams", 
      "Hybrid Gaming Sports Week - 300+ participants",
      "Indonesia Gaming League - 100 professional teams"
    ],
    packages: [
      {
        name: "Basic Hybrid",
        description: "Up to 100 teams"
      },
      {
        name: "Pro Tournament",
        description: "Up to 200 teams"
      },
      {
        name: "Championship Level",
        description: "Up to 300+ teams"
      }
    ]
  },
  {
    id: 3,
    title: "Eventime Expo",
    description: "Large showcase platform for communities and brands with various booths, workshops, and exciting competitions.",
    icon: "Trophy",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxleHBvJTIwZXZlbnR8ZW58MHx8fHwxNjg5NTAzMDAwfDA&ixlib=rb-4.0.3&q=80&w=1080",
    detailedDescription: "Create memorable expos with showcase platforms that bring together communities, brands, and visitors in one place. We manage all aspects from booth setup to interactive activities.",
    features: [
      "Professional booth setup and design",
      "Exhibitor and visitor registration system", 
      "Workshop and seminar areas",
      "Competition and doorprize management",
      "Structured networking sessions",
      "Digital catalog and mobile app",
      "Live streaming of main events",
      "Marketing support for exhibitors"
    ],
    pastEvents: [
      "Jakarta Gaming Expo 2024 - 100+ exhibitors",
      "Sports Community Fair - 80 booths",
      "Tech Innovation Showcase - 150 startups",
      "Community Festival Jakarta - 200+ communities"
    ],
    packages: [
      {
        name: "Basic Expo Package",
        description: "Up to 50+ exhibitors"
      },
      {
        name: "Professional Expo Package",
        description: "Up to 100+ exhibitors"
      },
      {
        name: "Premium Expo Package",
        description: "Up to 200+ exhibitors"
      }
    ]
  }
];

// Mock event registration handler
export const handleEventRegistration = (eventId, eventTitle) => {
  console.log(`Mock event registration for: ${eventTitle} (ID: ${eventId})`);
  
  return new Promise((resolve) => {
    setTimeout(() => {
      // Store in localStorage for demo purposes
      const registrations = JSON.parse(localStorage.getItem('eventime_registrations') || '[]');
      registrations.push({
        eventId,
        eventTitle,
        registrationId: Date.now(),
        timestamp: new Date().toISOString(),
        status: 'registered'
      });
      localStorage.setItem('eventime_registrations', JSON.stringify(registrations));
      
      resolve({ 
        success: true, 
        message: `Berhasil mendaftar untuk "${eventTitle}"! Tim kami akan menghubungi Anda segera.` 
      });
    }, 800);
  });
};

// Mock service consultation handler
export const handleServiceConsultation = (serviceId, serviceTitle) => {
  console.log(`Mock consultation request for: ${serviceTitle} (ID: ${serviceId})`);
  
  return new Promise((resolve) => {
    setTimeout(() => {
      // Store in localStorage for demo purposes
      const consultations = JSON.parse(localStorage.getItem('eventime_consultations') || '[]');
      consultations.push({
        serviceId,
        serviceTitle,
        consultationId: Date.now(),
        timestamp: new Date().toISOString(),
        status: 'pending'
      });
      localStorage.setItem('eventime_consultations', JSON.stringify(consultations));
      
      resolve({ 
        success: true, 
        message: `Permintaan konsultasi untuk "${serviceTitle}" telah diterima! Tim kami akan menghubungi Anda dalam 24 jam.` 
      });
    }, 800);
  });
};